import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { ISystemStepFieldsResponse, ISystemStepValuesResponse } from "../models/SystemStepField";

export default function useSystemStepFields(vehicleId?: string) {
  const { get } = useApiHelper();

  const systemStepFields = useQuery({
    queryKey: ["system-step-fields"],
    queryFn: () => get<ISystemStepFieldsResponse>("/systemstepfield"),
    // The list only changes with an API release.
    staleTime: 1000 * 60 * 60,
  });

  const systemStepValues = useQuery({
    queryKey: ["system-step-values", vehicleId],
    queryFn: () => get<ISystemStepValuesResponse>(`/systemstepfield/vehicle/${vehicleId}`),
    enabled: !!vehicleId,
    staleTime: 1000 * 60,
  });

  return {
    systemStepFields,
    systemStepValues,
  };
}
